import { render } from "./OriginalCodeList.vue?vue&type=template&id=1840b2b9&scoped=true"
import script from "./OriginalCodeList.vue?vue&type=script&lang=js"
export * from "./OriginalCodeList.vue?vue&type=script&lang=js"

import "./OriginalCodeList.vue?vue&type=style&index=0&id=1840b2b9&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1840b2b9"]])

export default __exports__